import * as React from 'react';
import { useState } from 'react';
import Container from '@mui/material/Container';
import { useGet } from '../lib/api/hooks';
import { Backdrop, CircularProgress } from '@mui/material';
import GeneralSection, {
    GeneralSectionDto
} from '../components/ApplicationConfiguration/GeneralSection';
import AncillaryHoursSection, {
    AncillaryHoursSectionDto
} from '../components/ApplicationConfiguration/AncillaryHoursSection';
import SupportSection from '../components/ConfigurationSupport/SupportSection';
import { SupportDataDto } from '../lib/models/SupportModels';
import ClinicalReviewSection from '../components/ClinicalReviewConfiguration/ClinicalReviewSection';
import { ReviewExtendReasonDto, ReviewTimeDto } from '../lib/dtos/ReviewDtos';
import { backdropStyle } from '../style';

/**Interface for Configure page that contains particular sections.
 * To add new sections, just add a new field. */
export interface ConfigurePageDto {
    general: GeneralSectionDto;
    ancillaryHours: AncillaryHoursSectionDto;
    support: SupportDataDto;
    reviewTimes: ReviewTimeDto[];
    reviewExtendReasons: ReviewExtendReasonDto[];
}

const ConfigurePage = () => {
    const [expandedPanels, setExpandedPanels] = useState<string[]>([]);
    const { data, loading } = useGet<ConfigurePageDto>(`appconfigs/configure-page`);

    const handleChange = (isExpanded: boolean, panel: string) => {
        isExpanded
            ? setExpandedPanels((expandedPanels) => [...expandedPanels, isExpanded ? panel : ''])
            : setExpandedPanels((expandedPanels) =>
                  expandedPanels.filter((n) => !n.startsWith(panel))
              );
    };

    return (
        <Container
            maxWidth="lg"
            sx={{
                pt: '1.875rem'
            }}>
            {!loading ? (
                data && (
                    <>
                        <GeneralSection
                            dto={data.general}
                            isExpanded={
                                expandedPanels instanceof Array
                                    ? expandedPanels.includes(data?.general?.name)
                                    : false
                            }
                            expandedPanels={expandedPanels}
                            onExtendedPanelsChange={handleChange}
                        />
                        <ClinicalReviewSection
                            dto={{
                                reviewTimes: data.reviewTimes,
                                reviewExtendReasons: data.reviewExtendReasons
                            }}
                            isExpanded={
                                expandedPanels instanceof Array
                                    ? expandedPanels.includes('Clinical Review')
                                    : false
                            }
                        />
                        <AncillaryHoursSection
                            dto={data.ancillaryHours}
                            isExpanded={
                                expandedPanels instanceof Array
                                    ? expandedPanels.includes(data.ancillaryHours?.name ?? '')
                                    : false
                            }
                            expandedPanels={expandedPanels}
                            onExtendedPanelsChange={handleChange}
                        />
                        <SupportSection
                            dto={data.support}
                            isExpanded={
                                expandedPanels instanceof Array
                                    ? expandedPanels.includes('Support')
                                    : false
                            }
                        />
                    </>
                )
            ) : (
                <>
                    <Backdrop sx={backdropStyle} open={loading}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                </>
            )}
        </Container>
    );
};

export default ConfigurePage;
